module.exports = __webpack_public_path__ + "static/media/img_noble.5f887bdc.jpg";